import React, { useRef, useState } from 'react';

import ExplorerIcon, { ExplorerIconName } from 'components/FileViewer/ExplorerIcon';
import NewFolderDialog from 'components/FileViewer/NewFolderDialog';
import { ExplorerFolder } from 'helper/products/fileExplorer';

import './index.scss';

function ActionButton({
  icon, label, onClick, disabled = false,
}: {
  icon: ExplorerIconName;
  label: string;
  onClick: () => void;
  disabled?: boolean;
}) {
  return (
    <button type="button" className="file-explorer-action" onClick={onClick} disabled={disabled}>
      <span className="file-explorer-action-icon" aria-hidden="true">
        <ExplorerIcon name={icon} size={16} strokeWidth={2.2} />
      </span>
      <span className="file-explorer-action-label">{label}</span>
    </button>
  );
}

/** Ações da Ampere dentro de uma pasta: criar subpasta e enviar arquivos. */
export default function ManageActions({
  folder,
  isCreating,
  isUploading,
  onCreateFolder,
  onUpload,
}: {
  folder: ExplorerFolder;
  isCreating: boolean;
  isUploading: boolean;
  onCreateFolder: (name: string) => Promise<boolean>;
  onUpload: (files: File[]) => void;
}) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);

  return (
    <div className="file-explorer-actions">
      <ActionButton icon="plus" label="Nova pasta" onClick={() => setDialogOpen(true)} />
      <ActionButton
        icon="upload"
        label="Enviar arquivos"
        onClick={() => fileInputRef.current?.click()}
        disabled={isUploading}
      />
      <input
        ref={fileInputRef}
        type="file"
        multiple
        hidden
        tabIndex={-1}
        aria-hidden="true"
        onChange={(event) => {
          onUpload(Array.from(event.target.files ?? []));
          // Permite reenviar o mesmo arquivo em seguida.
          // eslint-disable-next-line no-param-reassign
          event.target.value = '';
        }}
      />
      <NewFolderDialog
        open={dialogOpen}
        folder={folder}
        isCreating={isCreating}
        onCreate={onCreateFolder}
        onClose={() => setDialogOpen(false)}
      />
    </div>
  );
}
